import { Component } from '@angular/core';

@Component({
  selector: 'app-discharge-bed',
  templateUrl: './discharge-bed.component.html',
  styleUrls: ['./discharge-bed.component.css'],
  standalone: false,
})
export class DischargeBedComponent {}
